import { DelayFactory } from './delay/delayFactory'
import { IExponentialBackOffOptions } from './interface/types'

export class ExponentialBackOff<T> {
  private attemptNumber = 0

  constructor(
    private request: () => Promise<T>,
    private options: IExponentialBackOffOptions,
  ) {}

  public async execute(): Promise<T> {
    while (!this.attemptLimitReached) {
      try {
        await this.applyDelay()
        return await this.request()
      } catch (e) {
        this.attemptNumber++
        const shouldRetry = await this.options.retry(e, this.attemptNumber)

        if (!shouldRetry || this.attemptLimitReached) {
          throw e
        }
      }
    }

    throw new Error('Something went wrong.')
  }

  private get attemptLimitReached() {
    return this.attemptNumber >= this.options.numberOfAttempts
  }

  private async applyDelay() {
    const delay = DelayFactory(this.options, this.attemptNumber)
    await delay.apply()
  }
}
